import React from "react";
import image1 from "../assets/image1.png"; // story image
import image2 from "../assets/image2.png"; // hero image
import "../theme.css"; // make sure theme.css is imported once (can be in App.js too)

const AboutUsScreen = () => {
  return (
    <div className="about-us-section">
      {/* Hero Section */}
      <section
        className="hero-section position-relative d-flex align-items-center justify-content-center text-center"
        style={{
          backgroundImage: `url(${image2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "60vh"
        }}
      >
        <div className="overlay position-absolute w-100 h-100" style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}></div>
        <h1 className="hero-title position-relative text-white display-4">SYUKRA</h1>
      </section>

      {/* About Section */}
      <section className="container text-center py-5">
        <h2 className="section-title mb-3">About Syukra</h2>
        <p className="section-description mx-auto">
          Syukra is not just a men’s fashion brand — it’s a reflection of attitude,
          ambition, and authenticity. Built for the modern man who values comfort
          as much as class, every Syukra piece tells a story of confidence and quiet
          strength. With clean cuts, rich textures, and a premium touch, Syukra
          celebrates men who stand out not by trying too hard, but by simply being
          themselves — effortlessly exquisite.
        </p>
      </section>

      {/* Our Story Section */}
      <section className="story-section py-5 bg-light">
        <div className="container d-flex flex-column flex-md-row align-items-center gap-4">
          <img
            src={image1}
            alt="Our Story"
            className="story-image rounded shadow w-100 w-md-50"
          />
          <div className="story-text w-100 w-md-50">
            <h4 className="text-uppercase text-muted small mb-2">Our Heritage</h4>
            <h2 className="section-title mb-3">Our Story</h2>
            <p className="text-muted mb-3">
              Every piece of Syukra is crafted with meticulous attention to detail,
              honoring traditional craftsmanship while embracing contemporary
              design. We believe in creating fashion that transcends trends and
              stands the test of time.
            </p>
            <ul className="list-unstyled text-start text-muted">
              <li><strong>• Made in Bharat:</strong> Proudly crafted in India, supporting local artisans.</li>
              <li><strong>• Swadeshi Values:</strong> Committed to locally made, sustainable products.</li>
              <li><strong>• Natural Fabrics:</strong> Exclusively using organic cotton, linen, and silk.</li>
              <li><strong>• Environmental Commitment:</strong> Sustainability and minimal impact first.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-section container text-center py-5">
        <h2 className="section-title mb-4">Our Core Values</h2>
        <div className="row g-4">
          {[
            {
              title: "Authenticity",
              desc: "We believe in genuine expression and honest craftsmanship. Every design reflects authenticity and integrity.",
            },
            {
              title: "Sustainability",
              desc: "Our dedication to the environment shapes every decision. We use eco-friendly materials and ethical production.",
            },
            {
              title: "Quality",
              desc: "Excellence is non-negotiable. From material selection to final stitching, we uphold the highest standards.",
            },
            {
              title: "Empowerment",
              desc: "We empower men to express individuality with confidence and authenticity.",
            },
          ].map((value, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3">
              <div className="value-card border rounded-4 p-4 h-100 hover-shadow">
                <h5 className="fw-semibold mb-2">{value.title}</h5>
                <p className="text-muted small">{value.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      
    </div>
  );
};

export default AboutUsScreen;
